import FilterGroupEnum from './enum/FilterGroup';
import options from './options';

const isValidFilter = (group: FilterGroupEnum, option: string): boolean =>
  options[group].some(item => item.value === option);

export default isValidFilter;
